
import { postAPI, getAPI } from '../../api/api'
import { REACT_APP_JOB } from '../../utils/common'

export async function updatePositionAPI(body: any){
  const Details = postAPI( REACT_APP_JOB + '/updatejobstatus', body)
  return Details
}

export async function getPositionsDetails(jobId: string){
  const Details = getAPI( REACT_APP_JOB + `/position/${jobId}?userRole=CS-RECRUITER`)
  return Details
}

export async function getAppliedCandidate(jobId: string, recruiterId: any){
  const Details = getAPI( REACT_APP_JOB + `/csr-applied-resources/${jobId}?recruiterId=${recruiterId}`)
  return Details
}
